import React from 'react';
import 'whatwg-fetch';
import { postEntity } from 'src/utils/entityApi';
import Select from 'react-select';
import withAuth from 'src/hoc/withAuth';

const apiOrigin = '/api/origin/';

const formRegexs = {
  name: {
    regEx: /^[A-zÀ-ÿ ]+$/,
    message: 'uniquement lettres et espaces',
  },
  lastname: {
    regEx: /^[A-zÀ-ÿ ]+$/,
    message: 'uniquement lettres et espaces',
  },
  phoneNumber: {
    regEx: /^(0|(00|\+)33)[12345679][0-9]{8}$/,
    message: 'invalide (ex: 0677896527)',
  },
  email: {
    regEx: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'invalide (ex: joe.dupont@gmail.com)',
  },
};

const textNonEntered = 'Non renseigné';

const oriState = {
  dataOrigin: undefined,
  name: undefined,
  nameIsValid: true,
  lastname: undefined,
  lastnameIsValid: true,
  phoneNumber: undefined,
  phoneNumberIsValid: true,
  email: undefined,
  emailIsValid: true,
  companyName: undefined,
  companyNameIsValid: true,
  job: undefined,
  jobs: undefined,
  jobIsValid: true,
  originId: -1,
};

class ModalContactPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
    this.checkFieldValid = this.checkFieldValid.bind(this);
    this.isFieldValid = this.isFieldValid.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleJobChange = (job) => {
    this.setState({
      job: job.name,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    let nameToCheck = undefined;
    if (this.state.name !== prevState.name) {
      nameToCheck = 'name';
    } else if (this.state.lastname !== prevState.lastname) {
      nameToCheck = 'lastname';
    } else if (this.state.phoneNumber !== prevState.phoneNumber) {
      nameToCheck = 'phoneNumber';
    } else if (this.state.email !== prevState.email) {
      nameToCheck = 'email';
    }

    if (nameToCheck) {
      this.checkFieldValid(nameToCheck);
    }
  }

  componentDidMount() {
    if (!this.props.myCustomer) {
      let queryURL = apiOrigin;
      let graphQL = '{ origins{ id, labelOrigin, active } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          this.setState({
            dataOrigin: data['data']['origins'],
          });
        })
        .catch((error) => {
          console.log('erreur fetch origins: \n' + error);
        });
    }

    this.getJobs();
  }

  isFieldValid(fieldName) {
    let inputValue;
    inputValue = this.state[fieldName];

    let regEx = new RegExp(formRegexs[fieldName].regEx);
    return regEx.test(inputValue);
  }

  checkFieldValid(fieldName) {
    if (fieldName !== 'originId') {
      if (!this.isFieldValid(fieldName)) {
        this.setState({
          [fieldName + 'IsValid']: false,
        });
      } else if (this.isFieldValid(fieldName) && !this.state[fieldName + 'IsValid']) {
        this.setState({
          [fieldName + 'IsValid']: true,
        });
      }
    }
  }

  getJobs = () => {
    this.props
      .authFetch('/api/jobs/', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((jobs) => {
        this.setState({ jobs });
      });
  };

  checkFormValid() {
    // loop through all the field to check their regEx integrity +++ handle the Toast Messages if invalid
    let isValid = true;
    let nbContactWay = 2; // check that there is at least the Email or the PhoneNumber
    for (let key in formRegexs) {
      if (formRegexs.hasOwnProperty(key)) {
        // check if not valid OR if field is empty
        if (!this.state[key] || this.state[key].trim() === '' || !this.state[key + 'IsValid']) {
          // the field is invalid
          if (
            (key === 'email' || key === 'phoneNumber') &&
            nbContactWay === 2 &&
            (!this.state[key] || this.state[key].trim() === '')
          ) {
            // invalid but still another contact way
            nbContactWay--;
          } else if (
            (key === 'email' || key === 'phoneNumber') &&
            nbContactWay === 1 &&
            (!this.state[key] || this.state[key].trim() === '')
          ) {
            // Not even one contact way available
            nbContactWay--;
            break; // no need to iterate through the end
          } else {
            // this is a normal field -> no integrity check
            isValid = false;
            this.setState({
              [key + 'IsValid']: false,
            });
          }
          //break;
        }
      }
    }

    if (!this.props.myCustomer && (!this.state.originId || this.state.originId === -1)) {
      isValid = false;
    }

    if (!isValid) {
      this.props.openToast(false, 'Invalide. Veuillez revoir le formulaire.');
    } else if (isValid && nbContactWay === 0) {
      this.props.openToast(false, 'Veuillez indiquer au moins un moyen de contact.');
      isValid = false; // block the post request
    }

    return isValid;
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataOrigin } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Contact</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>

            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>
                    Prénom{' '}
                    {!this.state.nameIsValid && this.state.name && this.state.name !== '' && (
                      <span className='label-invalid-msg'>{formRegexs['name'].message}</span>
                    )}
                  </label>

                  <input
                    name='name'
                    value={this.state.name}
                    onChange={this.handleInputChange}
                    type='text'
                    className={'form-control ' + (this.state.nameIsValid ? '' : 'invalid')}
                    placeholder='Prénom du contact'
                  />
                </div>
                <div className='form-group'>
                  <label>
                    Nom{' '}
                    {!this.state.lastnameIsValid && this.state.lastname && this.state.lastname !== '' && (
                      <span className='label-invalid-msg'>{formRegexs['lastname'].message}</span>
                    )}
                  </label>
                  <input
                    name='lastname'
                    value={this.state.lastname}
                    onChange={this.handleInputChange}
                    type='text'
                    className={'form-control ' + (this.state.lastnameIsValid ? '' : 'invalid')}
                    placeholder='Nom du contact'
                  />
                </div>
                <div className='form-group'>
                  <label>
                    Téléphone{' '}
                    {!this.state.phoneNumberIsValid && this.state.phoneNumber && this.state.phoneNumber !== '' && (
                      <span className='label-invalid-msg'>{formRegexs['phoneNumber'].message}</span>
                    )}
                  </label>
                  <input
                    name='phoneNumber'
                    value={this.state.phoneNumber}
                    onChange={this.handleInputChange}
                    type='text'
                    className={'form-control ' + (this.state.phoneNumberIsValid ? '' : 'invalid')}
                    placeholder='Numéro de téléphone'
                  />
                </div>
                <div className='form-group'>
                  <label>
                    Email{' '}
                    {!this.state.emailIsValid && this.state.email && this.state.email !== '' && (
                      <span className='label-invalid-msg'>{formRegexs['email'].message}</span>
                    )}
                  </label>
                  <input
                    name='email'
                    value={this.state.email}
                    onChange={this.handleInputChange}
                    type='text'
                    className={'form-control ' + (this.state.emailIsValid ? '' : 'invalid')}
                    placeholder='Email de contact'
                  />
                </div>
                <div className='form-group'>
                  <label>
                    Nom d'entreprise <i>(facultatif)</i>
                  </label>
                  <input
                    name='companyName'
                    value={this.state.companyName}
                    onChange={this.handleInputChange}
                    type='text'
                    className={'form-control '}
                    placeholder='Permet de rechercher le contact'
                  />
                </div>
                <div className='form-group'>
                  <label>
                    Job <i>(facultatif)</i>
                  </label>
                  {this.state.jobs && (
                    <Select
                      className='w-100'
                      value={this.state.job || ''}
                      onChange={this.handleJobChange}
                      labelKey='name'
                      valueKey='name'
                      placeholder='Poste occupé'
                      options={this.state.jobs}
                      clearable={false}
                    />
                  )}
                </div>
                {!this.props.myCustomer && (
                  <div className='form-group'>
                    <label>Origine</label>
                    <select
                      name='originId'
                      value={this.state.originId}
                      onChange={this.handleInputChange}
                      className='form-control'
                    >
                      <option value={-1}>Sélectionner origine</option>
                      {dataOrigin ? (
                        dataOrigin
                          .filter((data) => data.active)
                          .map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.labelOrigin}
                            </option>
                          ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </div>
                )}
                {this.props.myCustomer && (
                  <div className='form-group'>
                    <label>Client associé</label>
                    <select
                      name='customerId'
                      value={this.props.myCustomer.id}
                      onChange={this.handleInputChange}
                      className='form-control'
                      disabled
                    >
                      <option value={this.props.myCustomer.id}>{this.props.myCustomer.name}</option>
                    </select>
                  </div>
                )}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        // this.state.phoneNumber || this.state.email
        let json = {
          contact: {
            name: this.state.name[0].toUpperCase() + this.state.name.substring(1).toLowerCase(),
            lastname: this.state.lastname.toUpperCase(),
            phoneNumber:
              this.state.phoneNumber && this.state.phoneNumber.trim() !== '' ? this.state.phoneNumber : textNonEntered,
            email: this.state.email && this.state.email.trim() !== '' ? this.state.email : textNonEntered,
            job: this.state.job && this.state.job.trim() !== '' ? this.state.job : '',
            companyName: this.state.companyName && this.state.companyName.trim() !== '' ? this.state.companyName : '',
            origin: {
              id: this.state.originId,
            },
            competitor: {
              isPresent: false,
            },
            customer: {
              isPresent: false,
            },
          },
        };

        if (this.props.myCustomer) {
          json['customer'] = {
            id: this.props.myCustomer.id,
          };
        }

        this.props.onPostResult('contact', postEntity(this.props.authFetch, 'contact', json));
        this.close();
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalContactPost);
